/* eslint-disable @typescript-eslint/no-unused-vars */
export enum Topic {
    onSocketConnected = "onSocketConnected",
    onSocketDisconnected = "onSocketDisconnected",
    joinRoom = "joinRoom",
    gameProgress = "gameProgress",
    gameOccupied = "gameOccupied",
    gameFreed = "gameFreed",
    gameMaintenance = "gameMaintenance",
    gameStatus = "gameStatus",
    entryDoorScan = "entryDoorScan",
    teamStartsGame = "teamStartsGame",
    updateLeaderBoard = "updateLeaderBoard",
    gameMessage = "gameMessage",
    digitalInput = "digitalInput",
    digitalOutput = "digitalOutput",
    rfidScan = "rfidScan",
    rfidStatus = "rfidStatus",
    artnetGameProgress = "artnetGameProgress",
    artnetGameStatus = "artnetGameStatus",
    artnetGameLogic = "artnetGameLogic",
    artnetAllOff = "artnetAllOff",
    artnetAllOn = "artnetAllOn",
    digitalInputState = "digitalInputState",
    adminWarning = "adminWarning",
    deleteNotification = "deleteNotification",
    barCodeScan = "barCodeScan",
    printTickets = "printTickets",
    ticketPrinted = "ticketPrinted",
    ticketPrintError = "ticketPrintError",
    restartPrintQueue = "restartPrintQueue",
    resetIntroRoom = "resetIntroRoom",
    refreshRegisterSignage = "refreshRegisterSignage",
    settingsUpdated = "settingsUpdated",
    setLocale = "setLocale",
}
